export const EMPOWERING_CONSTANTS = {
  title: "Empowering You with Cloud Simplicity",
  subTitle: "Unlock the Power of OpenStack Without the Overhead",
  text: "OneMind’s MOST gives you all the flexibility and power of OpenStack—without the complexity of managing it yourself.",
};
